var render, staticRenderFns
import script from "./friendly_wrap.vue?vue&type=script&lang=js"
export * from "./friendly_wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports